import { Placeholder, PlaceholderLine, PlaceholderMedia, Shine } from 'rn-placeholder';
import { Card, Stack } from 'tamagui';

const RenderProfileCardPlaceholder = () => {
  return (
    <Card
      width={'100%'}
      shadowColor={'#000000'}
      shadowRadius={5}
      elevation={5}
      margin={5}
      shadowOpacity={0.2}
      // marginTop={70}
      paddingTop={20}
      paddingHorizontal={15}
      backgroundColor="$background"
    >
      <Placeholder Animation={Shine}>
        <PlaceholderLine width={80} />
        <Stack width={'100%'} display="flex">
          <PlaceholderLine
            width={80}
            style={[{ width: '100%', height: 60, borderRadius: 10, marginRight: 10 }]}
          />
        </Stack>
        <PlaceholderLine width={80} />
        <PlaceholderLine width={80} />
      </Placeholder>
    </Card>
  );
};

export default RenderProfileCardPlaceholder;
